import { render, staticRenderFns } from "./PurchasingPie.vue?vue&type=template&id=e0871362&scoped=true&"
import script from "./PurchasingPie.vue?vue&type=script&lang=js&"
export * from "./PurchasingPie.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingPie.vue?vue&type=style&index=0&id=e0871362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0871362",
  null
  
)

export default component.exports